const setAuthenticatedUser = (user) => ({
  type: "SET_AUTH_USER",
  payload: user,
});

const verifyAuthenticatedUser = () => ({
  type: "VERIFY_USER",
});

const updateUserPinVerification = (pinVerified) => ({
  type: "UPDATE_PIN_VERIFICATION",
  payload: pinVerified,
});

export {
  setAuthenticatedUser,
  verifyAuthenticatedUser,
  updateUserPinVerification,
};
